import { deleteField, FieldPath, updateDoc } from 'firebase/firestore';
import { draftChanges } from './storeDraft';

// One write at most, with no extra reads or subscriptions.
export default async function saveStoreDraft(reference, source, draft) {
  const changes = draftChanges(source, draft);
  if (changes.length === 0) return;
  const fields = changes.flatMap(({ path, value, removed }) => [
    new FieldPath(...path), removed ? deleteField() : value,
  ]);
  await updateDoc(reference, ...fields);
}
